export default "#define GLSLIFY 1\nvarying vec2 v_uv;\n\nvoid main() {\n    v_uv = uv;\n    vec3 pos = position;\n\n    gl_Position = projectionMatrix * modelViewMatrix * vec4(pos, 1.0);\n}";


//////////////////
// WEBPACK FOOTER
// ./scripts/shader/bubble.vert
// module id = 119
// module chunks = 0